import React, { Fragment, useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import "react-toastify/dist/ReactToastify.css";
import DataTableExtensions from "react-data-table-component-extensions";
import { useSelector } from "react-redux";
// import { toastDelPermission } from "../../utils/toastPermission";
import { adminInstance } from "../../config/axios";
import { toast } from "react-toastify";

const ListDatatable = ({
  myData,
  myClass,
  pagination,
  refreshData,
}) => {
  const result = useSelector((state) => state.admin);
  const { loginAdmin } = result || {};
  const { role } = loginAdmin || [];
  const [data, setData] = useState();

  useEffect(() => {
    setData(myData);
  }, [myData]);

  let editRole = role?.some((r) =>
    ["suUsers", "superAdmin", "writeCategory"].includes(r),
  );

  const handleToggleBlacklist = async (marketHashName, currentStatus, price) => {
    try {
      const response = await adminInstance().post(
        "/api/admin/toggleDepositBlacklist",
        { marketHashName, gameId: '252490', isBlacklisted: !currentStatus, price }
      );
      const { code, msg } = response.data;
      if (code === 200) {
        toast.success(msg || "Blacklist status updated");
        refreshData(); 
      } else {
        toast.error("Failed to update blacklist status");
      }
    } catch (error) {
      console.error(error);
      toast.error("Error updating blacklist status");
    }
  };

  const columnDefs = [
    {
      name: "Item Name",
      selector: (row) => row.marketHashName,
      sortable: true,
    },
    {
      name: "Price",
      selector: (row) => row.steam?.price || 0,
      sortable: true,
      cell: (row) => `$${row.steam?.price || 0}`,
    },
    {
      name: "Liquidity",
      selector: (row) => row.liquidity?.toFixed(2) || 0,
      sortable: true,
    },
    {
      name: "Steam Volume",
      selector: (row) => row.steam_volume,
      sortable: true,
    },
    {
      name: "Count",
      selector: (row) => row.steam?.count || 0,
      sortable: true,
    },
    {
      name: "Is Blacklisted",
      cell: (row) => (
        <span style={{ color: row.isBlacklisted ? "red" : "green" }}>
          {row.isBlacklisted ? "Yes" : "No"}
        </span>
      ),
      sortable: true,
    },
    {
      name: "Action",
      cell: (row) => (
        <ActionButton
          row={row}
          handleToggle={handleToggleBlacklist}
          editRole={editRole}
        />
      ),
    },
  ];

  useEffect(() => {
    if (!editRole) {
      columnDefs.pop();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [columnDefs]);

  return (
    <div>
      <Fragment>
        <DataTableExtensions
          columns={columnDefs}
          data={data}
          print={false}
          export={false}>
          <DataTable
            data={data}
            columns={columnDefs}
            className={myClass}
            pagination
            striped={true}
            center={true}
          />
        </DataTableExtensions>
      </Fragment>
    </div>
  );
};

const ActionButton = ({ row, handleToggle, editRole }) => {
  return (
    <div className="action-btn">
      {editRole && (
        <button
          onClick={() => handleToggle(row.marketHashName, row.isBlacklisted, row.steam?.price || 0)}
          className={`btn ${row.isBlacklisted ? "btn-success" : "btn-danger"}`}
          style={{ fontSize: 12, padding: "5px 10px" }}
        >
          {row.isBlacklisted ? "Allow" : "Block"}
        </button>
      )}
    </div>
  );
};

export default ListDatatable;